import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f05a3554"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"agreement-container xa-line__full-top\" data-v-f05a3554><div class=\"pb32\" data-v-f05a3554><div class=\"title mt16 ftw\" data-v-f05a3554>个人客户信息授权条款</div><div class=\"content\" data-v-f05a3554> 本人授权平安集团，除法律另有规定之外，将本人提供给平安集团的信息、享受平安集团服务产生的信息(包括本条款签署之前提供和产生的信息)以及平安集团根据本条款约定查询、收集的信息，用于平安集团及其因服务必要委托的合作伙伴为本人提供服务、推荐产品、开展市场调查与信息数据分析。 </div><div class=\"content\" data-v-f05a3554> 本人授权平安集团，除法律另有规定之外，基于为本人提供更优质服务和产品的目的，向平安集团因服务必要开展合作的伙伴提供、查询、收集本人的信息。 </div><div class=\"content\" data-v-f05a3554> 前述“信息”可能包括但不限于本人的身份信息、金融信息、生物识别信息、通信信息、医疗健康信息、行踪轨迹信息、电子设备信息、电子设备操作日志及其他与本人相关的信息。 为确保本人信息的安全，平安集团对上述信息负有保密义务，并尽最大努力采取各种措施保证信息安全。 </div><div class=\"content\" data-v-f05a3554> 本条款自本人签署时生效，具有独立法律效力，不受本条款所属合同或协议成立与否及效力状态变化的影响。 </div><div class=\"content\" data-v-f05a3554> 本条款所称“平安集团”是指中国平安保险(集团)股份有限公司及其直接或间接控股的公司，中国平安保险(集团)股份有限公司直接或间接作为其单一最大股东的公司，以及中国平安保险(集团)股份有限公司以其他方式直接或间接控制或有重大影响的主体。 </div><div data-v-f05a3554>注:您可〔致电客服热线(95511)〕取消或变更上述授权。</div></div></div>", 1)
const _hoisted_2 = { class: "footer xag-page__footer nongfu-button-wrap" }

import { useRouter } from 'vue-router'
import { Button } from 'vant'
import AppHeader from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'client-policy',
  setup(__props) {

const $router = useRouter()

function back() {
  $router.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "个人客户信息授权条款" }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        block: "",
        type: "success",
        class: "xa-vant-button",
        onClick: back
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})